export default __webpack_public_path__ + "static/media/002-soccer.13a39e69.svg";